export const homepage = {
  // Hero Section
  heroTitle: 'Trouvez Votre Voiture de Location Parfaite',
  heroSubtitle: 'Explorez le monde en toute liberté avec notre plateforme de location de voitures. Des milliers d\'agences partenaires de confiance vous proposent des véhicules de qualité, des tarifs transparents et un service clientèle exceptionnel pour transformer chaque voyage en expérience inoubliable.',
  searchCars: 'Rechercher des Voitures',
  findBookRental: 'Trouvez, réservez et louez une voiture en',
  easySteps: 'Étapes faciles.',
  getCarWherever: 'Obtenez une voiture où et quand vous en avez besoin avec un service professionnel et des prix compétitifs.',
  
  // Search Form
  location: 'Lieu',
  pickupDate: 'Date de Prise en Charge',
  returnDate: 'Date de Retour',
  
  // Steps Section
  rentWithSteps: 'Louez en suivant ces 3 étapes de travail',
  chooseLocation: 'Choisir l\'emplacement',
  chooseLocationDesc: 'Choisissez votre emplacement et trouvez votre meilleure voiture',
  pickupDateDesc: 'Sélectionnez votre date et heure de prise en charge pour réserver votre voiture',
  bookYourCar: 'Réservez votre voiture',
  bookYourCarDesc: 'Réservez votre voiture et nous vous la livrerons directement',
  
  // Features
  whyChooseKiraCar: 'Pourquoi Choisir KiraCar ?',
  whyChooseSubtitle: 'Découvrez le meilleur service de location de voitures avec nos agences vérifiées et un support client exceptionnel.',
  verifiedAgencies: 'Agences Vérifiées',
  verifiedAgenciesDesc: 'Toutes les agences de location sont soigneusement vérifiées pour votre sécurité et votre tranquillité d\'esprit.',
  support247: 'Support 24/7',
  support247Desc: 'Support client 24h/24 pour vous aider chaque fois que vous en avez besoin.',
  bestPrices: 'Meilleurs Prix',
  bestPricesDesc: 'Comparez les prix de plusieurs agences pour trouver les meilleures offres de location de voitures.',
  trustedReviews: 'Avis de Confiance',
  trustedReviewsDesc: 'Lisez de vrais avis de clients vérifiés pour prendre des décisions éclairées.',
  
  // Sections
  featuredCars: 'Voitures en Vedette',
  featuredCarsDesc: 'Découvrez nos voitures de location les plus populaires auprès d\'agences de confiance.',
  trustedAgencies: 'Agences de Confiance',
  trustedAgenciesDesc: 'Partenaire avec les agences de location de voitures les plus fiables dans le monde.',
  viewAllCars: 'Voir Toutes les Voitures',
  
  // CTA
  readyToStart: 'Prêt à Commencer Votre Voyage ?',
  readyToStartDesc: 'Rejoignez des milliers de clients satisfaits et trouvez votre voiture de location parfaite aujourd\'hui.',
  browseCars: 'Parcourir les Voitures',
  joinAsAgency: 'Rejoindre en tant qu\'Agence',
  
  // Footer
  quickLinks: 'Liens Rapides',
  forAgencies: 'Pour les Agences',
  agencyHelp: 'Aide aux Agences',
  termsOfService: 'Conditions d\'Utilisation',
  privacyPolicy: 'Politique de Confidentialité',
  allRightsReserved: 'Tous droits réservés',
}; 